import axios from 'axios';

/*
*  This file contains all axios calls related add contacts to automation
*/

const urlBase = '/app/text-voice-then';

export const getAccountPhoneNumberInfo = async () => {
    const { data } = await axios.get(`${urlBase}/account-phone-number`);

    return data;
};

export const getAutomationMessageInfo = async (automationMessageId) => {
    const { data } = await axios.get(`${urlBase}/${automationMessageId}`);

    return data;
};

export const createAutomationMessage = async (payload) => {
    const { data: { automationMessage } } = await axios.post(urlBase, payload);

    return automationMessage;
};

export const updateAutomationMessage = async (payload) => {
    await axios.put(urlBase, payload);
};
